export default "__VITE_ASSET__e3P1WMLC__"